import styled from 'styled-components/macro';
import { colorBlackTransparent300 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel1 } from '@yme/tokens/typography';
import { transformSrcSetToCss } from '@yme/utils/styles';
export const ContainerStyled = styled.div `
  position: relative;

  background-color: ${colorBlackTransparent300};
  ${({ srcSet, imageUrl }) => imageUrl && transformSrcSetToCss(srcSet, imageUrl)};

  height: 405px;
  background-size: cover;
  background-position: 50%;

  ${ADAPTIVE.maxWidth.tablet} {
    height: 330px;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    height: 154px;
  }
`;
export const TitleStyled = styled(HeadingLevel1) `
  position: absolute;

  bottom: 48px;
  left: 48px;

  ${ADAPTIVE.maxWidth.mobile} {
    bottom: 16px;
    left: 16px;
  }

  ${ADAPTIVE.maxWidth.tablet} {
    bottom: 28px;
    left: 24px;
  }
`;
